import { embed } from '../Helper/iFrame';

embed('youtube');
